import { FaTimes, FaCloudUploadAlt, FaTrash, FaEye, FaPlusCircle, FaCheckCircle, FaBan, FaEdit, FaTrashAlt, FaCheck, FaRegCommentDots, FaPaperclip } from "react-icons/fa";
import { useEffect, useState, useRef, useMemo } from "react";
import pathconfig from '../../pathconfig.json';
import axios from 'axios';
import moment from 'moment';
import { MdDownload } from "react-icons/md";
import { toastError, toastSuccess } from '../toaster';
import NodataFound from "../nodata";
import packjson from '../../../package.json';
import { useAppContextProvider } from '../../contextapi';

const Supplementary = (props) => {
    const [fileData, setFileData] = useState([]);
    const [fileUpdate, setFileUpdate] = useState([]);
    const fileInputRef = useRef(null);
    const { userProfile, setSidebarClose, setSupplementaryData, supplementaryGetData, setSupplementComment, alttextEnabled } = useAppContextProvider();
    const [deleteData, setDeleteData] = useState('');
    const [showconfirm, setConfirm] = useState(false);
    const [pendingCommentDelete, setPendingCommentDelete] = useState(null);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [showImageModal, setShowImageModal] = useState(false);
    const [showAudioModal, setShowAudioModal] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(null);
    const [currentImage, setCurrentImage] = useState(null);
    const [currentAudio, setCurrentAudio] = useState(null);
    const [availableSubtitles, setAvailableSubtitles] = useState([]);
    const [selectedSubtitle, setSelectedSubtitle] = useState(null);
    const [subtitleTracks, setSubtitleTracks] = useState([]);
    const [isDownloading, setIsDownloading] = useState({});
    const [activeAudioCaption, setActiveAudioCaption] = useState('');
    const [isVideoLoading, setIsVideoLoading] = useState(false);
    const [isVideoBuffering, setIsVideoBuffering] = useState(false);
    const [isImageRendering, setIsImageRendering] = useState(false);
    const [isImageLoading, setIsImageLoading] = useState(false);
    const [isAudioLoading, setIsAudioLoading] = useState(false);
    const [loadingItemId, setLoadingItemId] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [comments, setComments] = useState({});
    const [commentInput, setCommentInput] = useState({});
    const [showCommentInput, setShowCommentInput] = useState({});
    const [editingCommentId, setEditingCommentId] = useState(null);
    const [editingCommentText, setEditingCommentText] = useState('');
    const videoRef = useRef(null);
    const audioRef = useRef(null);
    const closeBtnRef = useRef(null);
    const commentInputRef = useRef({});
    const editCommentRef = useRef(null);

    // CSS Loader Component
    const CSSLoader = () => (
       <span className="cssLoader"></span>
    );

    // Small CSS Loader for buttons
    const SmallCSSLoader = () => (
        <div style={{
            width: '12px',
            height: '12px',
            border: '2px solid rgba(63, 82, 163, 0.3)',
            borderTop: '2px solid #3f52a3',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            display: 'inline-block'
        }}>
            <style jsx>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );

    useEffect(() => {
        if (alttextEnabled && props.supplementComments){
            setComments(props.supplementComments);
            setSupplementComment(props.supplementComments);
        }
     }, [props.supplementComments, alttextEnabled]);

    useEffect(() => {
        if (supplementaryGetData) {
            setFileUpdate(supplementaryGetData);
        }
        getFiles(userProfile.docid);
    }, [supplementaryGetData, userProfile.docid]);

   useEffect(() => {
                    if (closeBtnRef.current) {
                        closeBtnRef.current.focus();
                    }
        }, [props.leftsidebarvalue])

    // Add ESC key listener
    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape') {
                if (showVideoModal) {
                    closeVideoModal();
                } else if (showImageModal) {
                    closeImageModal();
                } else if (showAudioModal) {
                    closeAudioModal();
                }
            }
        };

        document.addEventListener('keydown', handleEscKey);
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [showVideoModal, showImageModal, showAudioModal]);

    // Add global CSS for animations
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `;
        document.head.appendChild(style);
        
        return () => {
            document.head.removeChild(style);
        };
    }, []);

 const getFiles = (value) => {
    let url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].retrievefiles}`;
    let GetDetailDataString = localStorage.getItem(`${value}_init-getdetails`);
    let GetDetailData = JSON.parse(GetDetailDataString);

    const basePath = `${GetDetailData.Articledetails.ArtResourcePath}/Supplementary`;

    var data = {
        InputPath: basePath,
    };

    axios.post(url, data)
        .then((response) => {

            const filteredFiles = response.data.filter(file => {
                const relative = file.path.replace(basePath + "/", "");
                return !relative.includes("/");
            });

            setFileData(filteredFiles);
            console.log(filteredFiles, 'filteredFiles')

        }).catch((error) => {
            console.log(error)
            toastError(error.message);
        })
}

    // Check if file is a video
    const isVideoFile = (filename) => {
        const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', 'm4v', '3gp', 'ogv'];
        const extension = filename.split('.').pop().toLowerCase();
        return videoExtensions.includes(extension);
    };

    // Check if file is an audio
    const isAudioFile = (filename) => {
        const audioExtensions = ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a', 'wma'];
        const extension = filename.split('.').pop().toLowerCase();
        return audioExtensions.includes(extension);
    };

    // Check if file is an image
    const isImageFile = (filename) => {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'tiff', 'ico'];
        const extension = filename.split('.').pop().toLowerCase();
        return imageExtensions.includes(extension);
    };

    // Check if file is a subtitle file
    const isSubtitleFile = (filename) => {
        const subtitleExtensions = ['srt', 'vtt', 'ass', 'ssa', 'sub', 'sbv', 'cc', 'ttml'];
        const extension = filename.split('.').pop().toLowerCase();
        return subtitleExtensions.includes(extension);
    };

    // Check if file should show download icon (not video, audio, or image)
    const shouldShowDownloadIcon = (filename) => {
        // return !isVideoFile(filename) && !isAudioFile(filename) && !isImageFile(filename) && !isSubtitleFile(filename);
        return true;
    };

    // Find the paired .ttml file for a given video filename (e.g. mmc04-01-xxx.mp4 → mmc04-01-xxx.ttml)
    const findTtmlForVideo = (videoFilename) => {
        const videoBaseName = videoFilename.substring(0, videoFilename.lastIndexOf('.'));
        return fileData.find(file => {
            const fname = file.path.split('/').pop();
            const ext = fname.split('.').pop().toLowerCase();
            const base = fname.substring(0, fname.lastIndexOf('.'));
            return ext === 'ttml' && base === videoBaseName;
        }) || null;
    };

    // Find all subtitle files for a video
    const findSubtitlesForVideo = (videoFilename) => {
        const videoBaseName = videoFilename.substring(0, videoFilename.lastIndexOf('.'));
        const subtitleFiles = fileData.filter(file => {
            const filename = file.path.split('/').pop();
            const fileBaseName = filename.substring(0, filename.lastIndexOf('.'));
            return isSubtitleFile(filename) && fileBaseName.startsWith(videoBaseName);
        }).sort((a, b) => {
            const extA = a.path.split('.').pop().toLowerCase();
            const extB = b.path.split('.').pop().toLowerCase();
            const order = ['ttml', 'vtt', 'srt', 'ass', 'ssa', 'sub', 'sbv', 'cc'];
            const indexA = order.indexOf(extA);
            const indexB = order.indexOf(extB);
            return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
        });
        return subtitleFiles;
    };

    // Get file blob URL with proper MIME type - Fixed to prevent multiple calls
    const getFileBlobUrl = async (path, mimeType) => {
        try {
            let urlPath = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].download}`;
            const response = await axios.post(urlPath, {
                blobUrl: path,
                type: mimeType
            }, {
                responseType: 'blob',
            });
            return window.URL.createObjectURL(new Blob([response.data], { type: mimeType }));
        } catch (error) {
            console.error('Error getting file blob:', error);
            toastError('Failed to load file');
            return null;
        }
    };

    // Build a direct GET URL so media elements can stream (progressive
    // download + Range-based seeking) instead of waiting for a full blob.
    // Returns null when the environment has no streamVideo endpoint yet,
    // in which case callers fall back to the blob-download path.
    const getStreamUrl = (path, mimeType) => {
        const envConfig = pathconfig[packjson.environment];
        if (!envConfig.streamVideo) return null;
        return `${envConfig.baseUrl}${envConfig.streamVideo}?blobUrl=${encodeURIComponent(path)}&type=${encodeURIComponent(mimeType)}`;
    };

    // If the streaming request fails (endpoint not deployed, bad path),
    // retry the same media once through the blob-download path.
    const handleStreamError = async (mediaType) => {
        const current = mediaType === 'video' ? currentVideo : mediaType === 'audio' ? currentAudio : currentImage;
        if (!current?.isStream || current.fallbackTried) {
            if (mediaType === 'video') setIsVideoBuffering(false);
            if (mediaType === 'image') setIsImageRendering(false);
            return;
        }
        const getMime = mediaType === 'video' ? getVideoMimeType : mediaType === 'audio' ? getAudioMimeType : getImageMimeType;
        const blobUrl = await getFileBlobUrl(current.path, getMime(current.filename));
        if (!blobUrl) {
            if (mediaType === 'video') setIsVideoBuffering(false);
            if (mediaType === 'image') setIsImageRendering(false);
            return;
        }
        const updated = { ...current, url: blobUrl, isStream: false, fallbackTried: true };
        if (mediaType === 'video') {
            setCurrentVideo(updated);
        } else if (mediaType === 'audio') {
            setCurrentAudio(updated);
        } else {
            setCurrentImage(updated);
        }
    };

    // Get subtitle content
    const getSubtitleContent = async (path) => {
        try {
            let urlPath = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].download}`;
            const response = await axios.post(urlPath, {
                blobUrl: path,
                type: 'text/plain'
            }, {
                responseType: 'text',
            });
            return response.data;
        } catch (error) {
            console.error('Error getting subtitle:', error);
            return '';
        }
    };

    // Convert SRT to VTT format if needed
    const convertSrtToVtt = (srtContent) => {
        if (srtContent.startsWith('WEBVTT')) {
            return srtContent;
        }
        
        let vttContent = 'WEBVTT\n\n';
        vttContent += srtContent.replace(/(\d{2}):(\d{2}):(\d{2}),(\d{3})/g, '$1:$2:$3.$4');
        return vttContent;
    };

    // Convert TTML to VTT format
const convertTtmlToVtt = (ttmlContent) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(ttmlContent, 'text/xml');
    const cues = xmlDoc.getElementsByTagName('p');

    const frameRate = 30;

    const convertTime = (time) => {
        // format HH:MM:SS:FF
        const parts = time.split(':');
        if (parts.length !== 4) return time;

        const [hh, mm, ss, ff] = parts.map(Number);
        const ms = Math.round((ff / frameRate) * 1000);

        const msStr = ms.toString().padStart(3, '0');

        return `${String(hh).padStart(2,'0')}:${String(mm).padStart(2,'0')}:${String(ss).padStart(2,'0')}.${msStr}`;
    };

    let vtt = 'WEBVTT\n\n';

    for (let cue of cues) {
        const begin = cue.getAttribute('begin');
        const end = cue.getAttribute('end');

        let text = cue.innerHTML
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<[^>]+>/g, '')
            .trim();

        if (begin && end && text) {
            const start = convertTime(begin);
            const stop = convertTime(end);

            vtt += `${start} --> ${stop}\n${text}\n\n`;
        }
    }

    return vtt;
};

    // Get MIME type for video
    const getVideoMimeType = (filename) => {
        const extension = filename.split('.').pop().toLowerCase();
        const mimeTypes = {
            'mp4': 'video/mp4',
            'avi': 'video/x-msvideo',
            'mov': 'video/quicktime',
            'wmv': 'video/x-ms-wmv',
            'flv': 'video/x-flv',
            'webm': 'video/webm',
            'mkv': 'video/x-matroska',
            'm4v': 'video/x-m4v',
            '3gp': 'video/3gpp',
            'ogv': 'video/ogg'
        };
        return mimeTypes[extension] || 'video/mp4';
    };

    // Get MIME type for audio
    const getAudioMimeType = (filename) => {
        const extension = filename.split('.').pop().toLowerCase();
        const mimeTypes = {
            'mp3': 'audio/mpeg',
            'wav': 'audio/wav',
            'ogg': 'audio/ogg',
            'aac': 'audio/aac',
            'flac': 'audio/flac',
            'm4a': 'audio/mp4',
            'wma': 'audio/x-ms-wma'
        };
        return mimeTypes[extension] || 'audio/mpeg';
    };

    // Get MIME type for image
    const getImageMimeType = (filename) => {
        const extension = filename.split('.').pop().toLowerCase();
        const mimeTypes = {
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'png': 'image/png',
            'gif': 'image/gif',
            'bmp': 'image/bmp',
            'svg': 'image/svg+xml',
            'webp': 'image/webp',
            'tiff': 'image/tiff',
            'ico': 'image/x-icon'
        };
        return mimeTypes[extension] || 'image/jpeg';
    };

    // Play video with subtitle selection - Fixed to prevent multiple API calls
    const playVideo = async (videoItem) => {
        // Prevent multiple calls if already loading
        if (isVideoLoading || loadingItemId === videoItem.path) {
            return;
        }

        setIsVideoLoading(true);
        setLoadingItemId(videoItem.path);

        try {
            const filename = videoItem.path.split('/').pop();
            const mimeType = getVideoMimeType(filename);
            const streamUrl = getStreamUrl(videoItem.path, mimeType);
            const videoUrl = streamUrl || await getFileBlobUrl(videoItem.path, mimeType);
            if (!videoUrl) {
                setIsVideoLoading(false);
                setLoadingItemId(null);
                return;
            }

            const subtitleFiles = findSubtitlesForVideo(filename);
            const subtitleTracks = [];
            
            // Process subtitles sequentially to avoid multiple API calls
            for (const subtitleFile of subtitleFiles) {
                const subtitleContent = await getSubtitleContent(subtitleFile.path);
                const filename = subtitleFile.path.split('/').pop();
                const extension = filename.split('.').pop().toLowerCase();
                let vttContent;
                if (extension === 'ttml') {
                    vttContent = convertTtmlToVtt(subtitleContent);
                } else if (extension === 'srt') {
                    vttContent = convertSrtToVtt(subtitleContent);
                } else {
                    vttContent = subtitleContent; // assume VTT or other supported format
                }
                const subtitleBlob = new Blob([vttContent], { type: 'text/vtt' });
                const subtitleUrl = window.URL.createObjectURL(subtitleBlob);
                
                subtitleTracks.push({
                    kind: 'subtitles',
                    src: subtitleUrl,
                    srcLang: 'en',
                    label: filename,
                    default: subtitleTracks.length === 0
                });
            }

            setIsVideoBuffering(true);
            setCurrentVideo({
                ...videoItem,
                url: videoUrl,
                filename: filename,
                isStream: !!streamUrl
            });
            setAvailableSubtitles(subtitleFiles);
            setSubtitleTracks(subtitleTracks);
            
            if (subtitleTracks.length > 0) {
                setSelectedSubtitle(subtitleTracks[0]);
            } else {
                setSelectedSubtitle(null);
            }
            
            setShowVideoModal(true);
        } catch (error) {
            console.error('Error playing video:', error);
            toastError('Failed to load video');
        } finally {
            setIsVideoLoading(false);
            setLoadingItemId(null);
        }
    };

    // Play audio - New function for audio files with support for subtitles (including TTML)
    const playAudio = async (audioItem) => {
        // Prevent multiple calls if already loading
        if (isAudioLoading || loadingItemId === audioItem.path) {
            return;
        }

        setIsAudioLoading(true);
        setLoadingItemId(audioItem.path);

        try {
            const filename = audioItem.path.split('/').pop();
            const mimeType = getAudioMimeType(filename);
            const streamUrl = getStreamUrl(audioItem.path, mimeType);
            const audioUrl = streamUrl || await getFileBlobUrl(audioItem.path, mimeType);
            if (!audioUrl) {
                setIsAudioLoading(false);
                setLoadingItemId(null);
                return;
            }

            const subtitleFiles = findSubtitlesForVideo(filename);
            const subtitleTracks = [];

            for (const subtitleFile of subtitleFiles) {
                const subtitleContent = await getSubtitleContent(subtitleFile.path);
                const subtitleName = subtitleFile.path.split('/').pop();
                const extension = subtitleName.split('.').pop().toLowerCase();
                let vttContent;

                if (extension === 'ttml') {
                    vttContent = convertTtmlToVtt(subtitleContent);
                } else if (extension === 'srt') {
                    vttContent = convertSrtToVtt(subtitleContent);
                } else {
                    vttContent = subtitleContent;
                }

                const subtitleBlob = new Blob([vttContent], { type: 'text/vtt' });
                const subtitleUrl = window.URL.createObjectURL(subtitleBlob);

                subtitleTracks.push({
                    kind: 'subtitles',
                    src: subtitleUrl,
                    srcLang: 'en',
                    label: subtitleName,
                    default: subtitleTracks.length === 0
                });
            }

            setCurrentAudio({
                ...audioItem,
                url: audioUrl,
                filename: filename,
                isStream: !!streamUrl
            });
            
            setAvailableSubtitles(subtitleFiles);
            setSubtitleTracks(subtitleTracks);

            if (subtitleTracks.length > 0) {
                setSelectedSubtitle(subtitleTracks[0]);
            } else {
                setSelectedSubtitle(null);
            }
            
            setShowAudioModal(true);
        } catch (error) {
            console.error('Error playing audio:', error);
            toastError('Failed to load audio');
        } finally {
            setIsAudioLoading(false);
            setLoadingItemId(null);
        }
    };

    // View image - Fixed to prevent multiple API calls
    const viewImage = async (imageItem) => {
        // Prevent multiple calls if already loading
        if (isImageLoading || loadingItemId === imageItem.path) {
            return;
        }

        setIsImageLoading(true);
        setLoadingItemId(imageItem.path);

                try {
            const filename = imageItem.path.split('/').pop();
            const mimeType = getImageMimeType(filename);
            const streamUrl = getStreamUrl(imageItem.path, mimeType);
            const imageUrl = streamUrl || await getFileBlobUrl(imageItem.path, mimeType);
            if (!imageUrl) {
                setIsImageLoading(false);
                setLoadingItemId(null);
                return;
            }

            setIsImageRendering(true);
            setCurrentImage({
                ...imageItem,
                url: imageUrl,
                filename: filename,
                isStream: !!streamUrl
            });
            setShowImageModal(true);
        } catch (error) {
            console.error('Error viewing image:', error);
            toastError('Failed to load image');
        } finally {
            setIsImageLoading(false);
            setLoadingItemId(null);
        }
    };

    // Close video modal
    const closeVideoModal = () => {
        setShowVideoModal(false);
        setIsVideoBuffering(false);
        if (currentVideo?.url?.startsWith('blob:')) {
            window.URL.revokeObjectURL(currentVideo.url);
        }
        // Clean up subtitle URLs
        subtitleTracks.forEach(track => {
            if (track.src) {
                window.URL.revokeObjectURL(track.src);
            }
        });
        setCurrentVideo(null);
        setAvailableSubtitles([]);
        setSubtitleTracks([]);
        setSelectedSubtitle(null);
    };

    // Close audio modal
    const closeAudioModal = () => {
        setShowAudioModal(false);
        if (currentAudio?.url?.startsWith('blob:')) {
            window.URL.revokeObjectURL(currentAudio.url);
        }
        
        // Clean up subtitle URLs for audio
        subtitleTracks.forEach(track => {
            if (track.src) {
                window.URL.revokeObjectURL(track.src);
            }
        });

        setCurrentAudio(null);
        setAvailableSubtitles([]);
        setSubtitleTracks([]);
        setSelectedSubtitle(null);

    };


    // Close image modal
    const closeImageModal = () => {
        setShowImageModal(false);
        setIsImageRendering(false);
        if (currentImage?.url?.startsWith('blob:')) {
            window.URL.revokeObjectURL(currentImage.url);
        }
        setCurrentImage(null);
    };

    // Handle subtitle selection change
    const handleSubtitleChange = (event) => {
        const selectedIndex = event.target.value;
        const player = videoRef.current || audioRef.current;

        if (selectedIndex === 'none') {
            setSelectedSubtitle(null);
            setActiveAudioCaption('');
            if (player) {
                const tracks = player.textTracks;
                for (let i = 0; i < tracks.length; i++) {
                    tracks[i].mode = 'disabled';
                }
            }
        } else {
            setSelectedSubtitle(subtitleTracks[selectedIndex]);
            
            if (player) {
                const tracks = player.textTracks;
                for (let i = 0; i < tracks.length; i++) {
                    tracks[i].mode = i === parseInt(selectedIndex) ? 'showing' : 'disabled';
                }
            }
            setActiveAudioCaption('');
        }
    };

    // Audio subtitle cue tracking
    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) {
            return;
        }

        const updateActiveCaption = () => {
            const track = Array.from(audio.textTracks).find((t) => t.mode === 'showing');
            if (!track || !track.activeCues || track.activeCues.length === 0) {
                setActiveAudioCaption('');
                return;
            }

            const activeText = Array.from(track.activeCues)
                .map((cue) => (cue.text || '').trim())
                .filter(Boolean)
                .join('\n');

            setActiveAudioCaption(activeText);
        };

        const handleCueChange = () => {
            updateActiveCaption();
        };

        for (let i = 0; i < audio.textTracks.length; i++) {
            audio.textTracks[i].mode = selectedSubtitle ? (i === subtitleTracks.indexOf(selectedSubtitle) ? 'showing' : 'disabled') : 'disabled';
            audio.textTracks[i].addEventListener('cuechange', handleCueChange);
        }

        updateActiveCaption();

        return () => {
            for (let i = 0; i < audio.textTracks.length; i++) {
                audio.textTracks[i].removeEventListener('cuechange', handleCueChange);
            }
            setActiveAudioCaption('');
        };
    }, [selectedSubtitle, subtitleTracks, showAudioModal]);

    // Extract filename from full path
    const getFilenameFromPath = (path) => {
        return path ? path.split('/').pop() : path;
    };

    // Add comment
    const addComment = (filePath) => {
        const filename = getFilenameFromPath(filePath);
        const commentText = commentInput[filename]?.trim();
        if (!commentText) {
            toastError('Please enter a comment');
            return;
        }

        const newComment = {
            id: Date.now(),
            text: commentText,
            userName: userProfile.username || userProfile.email,
            role: userProfile.role,
            userId: userProfile.id || userProfile.email,
            timestamp: new Date().toISOString()
        };

        const updatedComments = {
            ...comments,
            [filename]: [...(comments[filename] || []), newComment]
        };

        setComments(updatedComments);

        setSupplementComment(updatedComments);

        setCommentInput(prev => ({
            ...prev,
            [filename]: ''
        }));

        setShowCommentInput(prev => ({
            ...prev,
            [filename]: false
        }));

        toastSuccess('Comment added successfully');
    };

    // Delete comment
    const deleteComment = (filePath, commentId) => {
        const filename = getFilenameFromPath(filePath);
        const updatedComments = {
            ...comments,
            [filename]: comments[filename].filter(c => c.id !== commentId)
        };

        setComments(updatedComments);

        setSupplementComment(updatedComments);

        toastSuccess('Comment deleted');
    };

    // Edit comment
    const startEditComment = (commentId, commentText) => {
        setEditingCommentId(commentId);
        setEditingCommentText(commentText);
        // Focus the edit textarea after state update and move cursor to the end
        setTimeout(() => {
            if (editCommentRef.current) {
                editCommentRef.current.focus();
                // Move cursor to the end of the text
                const length = commentText.length;
                editCommentRef.current.setSelectionRange(length, length);
            }
        }, 0);
    };

    // Save edited comment
    const saveEditComment = (filePath, commentId) => {
        if (!editingCommentText.trim()) {
            toastError('Comment cannot be empty');
            return;
        }

        const filename = getFilenameFromPath(filePath);
        const updatedComments = {
            ...comments,
            [filename]: comments[filename].map(c =>
                c.id === commentId ? { ...c, text: editingCommentText, timestamp: new Date().toISOString() } : c
            )
        };

        setComments(updatedComments);

        setSupplementComment(updatedComments);

        setEditingCommentId(null);
        setEditingCommentText('');
        toastSuccess('Comment updated');
    };

    // Cancel edit
    const cancelEditComment = () => {
        setEditingCommentId(null);
        setEditingCommentText('');
    };

    const fileDownload = async (fileType, path, skipLoading = false) => {
        if (!skipLoading && isDownloading[path]) {
            return; // Already downloading this specific file — button is already disabled
        }

        if (!skipLoading) {
            setIsDownloading(prev => ({ ...prev, [path]: true }));
        }
        
        try {
            let fileExtension = fileType.split('.').pop().toLowerCase();
            let mimeType;
            if (fileExtension === 'doc') {
                mimeType = 'application/msword';
            } else if (fileExtension === 'docx') {
                mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            } else if (fileExtension === 'xls') {
                mimeType = 'application/vnd.ms-excel';
            } else if (fileExtension === 'xlsx') {
                mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            } else if (fileExtension === 'ppt') {
                mimeType = 'vnd.ms-powerpoint';
            } else if (fileExtension === 'pptx') {
                mimeType = 'vnd.openxmlformats-officedocument.presentationml.presentation';
            } else if (fileExtension === '7z') {
                mimeType = 'x-7z-compressed';
            } else if (fileExtension === 'swf') {
                mimeType = 'x-shockwave-flash';
            } else {
                mimeType = `application/${fileExtension}`;
            }
            let urlPath = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].download}`;

            const response = await axios.post(urlPath, {
                blobUrl: path,
                type: mimeType
            }, {
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([response.data], { type: mimeType }));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `${fileType}`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            if (!skipLoading) {
                toastSuccess(`Supplementary file has been successfully downloaded.`);
            }

            // Auto-download the paired .ttml file whenever a video file is downloaded
            // if (!skipLoading && isVideoFile(fileType)) {
            //     const ttmlFile = findTtmlForVideo(fileType);
            //     if (ttmlFile) {
            //         const ttmlFilename = ttmlFile.path.split('/').pop();
            //         console.log(`[Supplementary] Auto-downloading paired TTML: ${ttmlFilename}`);
            //         await fileDownload(ttmlFilename, ttmlFile.path, true /* skipLoading */);
            //         toastSuccess(`Paired subtitle file (${ttmlFilename}) has also been downloaded.`);
            //     } else {
            //         console.log(`[Supplementary] No paired .ttml found for: ${fileType}`);
            //     }
            // }
        } catch (error) {
            console.error('Download error:', error);
            if (!skipLoading) {
                toastError('Failed to download file.');
            }
        } finally {
            if (!skipLoading) {
                setIsDownloading(prev => {
                    const updated = { ...prev };
                    delete updated[path];
                    return updated;
                });
            }
        }
    }

    // Modal download function for video/image/audio files
    const modalFileDownload = async (item) => {
        const filename = item.path.split('/').pop();
        await fileDownload(filename, item.path);
    };

    const handleFileupload = (e) => {
        try {
            let docId = userProfile.docid;
            const uploadedFile = e.target.files[0];
            const maxSize = 40 * 1024 * 1024;

            if (uploadedFile.size > maxSize) {
                toastError('File size exceeds maximum limit of 40MB');
                return;
            }
            let GetDetailDataString = localStorage.getItem(`${docId}_init-getdetails`);
            let GetDetailData = JSON.parse(GetDetailDataString);
            var formdata = new FormData();

            if (!GetDetailDataString) {
                toastError('Document details not found');
                return;
            }
            let fileName = e.target.files[0];
            formdata.append("files", e.target.files[0]);
            formdata.append("path", `${GetDetailData.Articledetails.ArtResourcePath}/Supplementary`);
            formdata.append("role", userProfile.role);
            formdata.append("username", userProfile.username)
            const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].supplymentAttachment}`;
            axios.post(url, formdata, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then((response) => {
                if (response.data.success) {
                    toastSuccess(response.data.message);
                    getFiles(docId);
                }
            }).catch(error => {
                // Show the backend rejection message (e.g. restricted file format)
                toastError(error.response?.data?.error || 'Failed to upload a file.');
            });
        } catch (error) {
            toastError('Error processing file upload');
            console.error('File upload error:', error);
        } finally {
            e.target.value = null;
        }
    }

    const deleteConfirm = (value) => {
        setDeleteData(value)
        setPendingCommentDelete(null);
        setConfirm(true)
    }

    const deleteCommentConfirm = (filePath, commentId) => {
        setPendingCommentDelete({ filePath, commentId });
        setConfirm(true);
    }

    const deleteAttchment = () => {
        let dataValue = deleteData;
        let data = {
            "filePath": dataValue.path,
        }
        const deleteUrl = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].deleteBlobFile}`
        axios.post(deleteUrl, data).then((response) => {
            setConfirm(false)
            toastSuccess(`${response.data.message}`);
            getFiles(userProfile.docid)
        }
       ).catch((error) => {
            console.log(error);
            toastError(error.message);
        })
    }

    const handleSearchChange = (value) => {
        setSearchText(value);
    };

    const getFilteredFiles = () => {
        if (!searchText.trim()) {
            return fileData;
        }
        const lowerSearchText = searchText.toLowerCase();
        return fileData.filter(item => {
            const filename = item.path.split('/').pop().toLowerCase();
            return filename.includes(lowerSearchText);
        });
    };

    // --- Master Copier alt-text actions (Create / Validate / Skip) for media files ---
    const isMC = userProfile?.role === 'Master Copier';

    // GIF is treated as an image elsewhere, but Master Copier actions/comments
    // apply only to video, audio and GIF supplementary files.
    const isGifFile = (filename) =>
        !!filename && filename.split('.').pop().toLowerCase() === 'gif';

    const supportsMcActions = (filename) =>
        !!filename &&
        (isVideoFile(filename) || isAudioFile(filename) || isGifFile(filename));

    // A "Replace File" attachment may target a caption/subtitle file (e.g.
    // "mmc4-ad.ttml") rather than the video/audio itself — those don't have
    // their own validate button, so resolve to whichever video/audio file(s)
    // it's paired with (mirrors findSubtitlesForVideo's prefix match, in
    // reverse; a caption base name can match more than one media file, e.g.
    // both "mmc4.mp4" and "mmc4.mp3", so all matches are flagged).
    const findBaseMediaForSubtitle = (subtitleFileName) => {
        const dot = subtitleFileName.lastIndexOf('.');
        const subtitleBase = dot > 0 ? subtitleFileName.substring(0, dot) : subtitleFileName;
        return fileData
            .filter((f) => {
                const fname = f.path.split('/').pop();
                if (!isVideoFile(fname) && !isAudioFile(fname)) return false;
                const fdot = fname.lastIndexOf('.');
                const base = fdot > 0 ? fname.substring(0, fdot) : fname;
                return subtitleBase.startsWith(base);
            })
            .map((f) => f.path.split('/').pop());
    };

    // Resolve a "Replace File" target to the file(s) that actually carry the
    // validate button: itself if it's already video/audio/gif, or the
    // video/audio it's a caption/subtitle for.
    const resolveMcTargetFilenames = (rawTargetName) => {
        if (supportsMcActions(rawTargetName)) return [rawTargetName];
        if (isSubtitleFile(rawTargetName)) return findBaseMediaForSubtitle(rawTargetName);
        return [];
    };

    // Attachments (from the Attachment tab) that are a Media attachment marked
    // "Replace File" with a target Supplementary file picked (e.g. mmc1.mp4,
    // mmc2.mp3, or a caption file like mmc4-ad.ttml) — keyed by the video/audio
    // file(s) that need the Master Copier's validation once such a
    // replacement has been submitted.
    const attachmentNotificationMap = useMemo(() => {
        const map = {};
        (props.fileItems || []).forEach((att) => {
            if (
                att.AttachType === 'mediaAttachment' &&
                att.mediaAction === 'replace' &&
                att.replaceMediaName &&
                att.replaceMediaName !== 'null'
            ) {
                resolveMcTargetFilenames(att.replaceMediaName).forEach((targetFilename) => {
                    const existing = map[targetFilename];
                    if (!existing || new Date(att.CreatedOn) > new Date(existing.CreatedOn)) {
                        map[targetFilename] = att;
                    }
                });
            }
        });
        return map;
    }, [props.fileItems, fileData]);

    const authorHasComment = (filename) =>
        (comments[filename] || []).some((c) => c.role === 'Author');

    // The Master Copier action for each media file is stored inside the
    // supplementComment map under a reserved key, so a single object carries
    // both the comments and the chosen action.
    const ACTIONS_KEY = '__mcActions__';

    // Action shown for a file: an explicit Master Copier choice always wins
    // (they retain full control to set Create/Validate/Skip). Only when they
    // haven't chosen yet does a pending "Replace File" attachment default the
    // file to "validate"; otherwise "validate" when the Author left a
    // comment, else "skip".
    const getSupplementAction = (filename) =>
        comments?.[ACTIONS_KEY]?.[filename] ||
        (attachmentNotificationMap[filename]
            ? 'validate'
            : (authorHasComment(filename) ? 'validate' : 'skip'));

    const handleSupplementActionChange = (filename, action) => {
        if (!filename) return;
        const updatedComments = {
            ...comments,
            [ACTIONS_KEY]: { ...(comments[ACTIONS_KEY] || {}), [filename]: action },
        };
        setComments(updatedComments);
        setSupplementComment(updatedComments);
    };

    // Render the Create / Validate / Skip action buttons for the Master Copier,
    // mirroring the Image List behaviour.
    const renderMcActionButtons = (filename) => {
        if (!alttextEnabled || !isMC || !supportsMcActions(filename)) return null;
        const current = getSupplementAction(filename);
        const options = [
            { value: 'create', label: 'Create', icon: <FaPlusCircle /> },
            { value: 'validate', label: 'Validate', icon: <FaCheckCircle /> },
            { value: 'skip', label: 'Skip', icon: <FaBan /> },
        ];
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {options.map(({ value, label, icon }) => {
                    const active = current === value;
                    return (
                        <label
                            key={value}
                            title={label}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '6px 14px',
                                borderRadius: '20px',
                                fontSize: '13px',
                                fontWeight: 600,
                                cursor: 'pointer',
                                whiteSpace: 'nowrap',
                                border: active ? '1px solid #fff' : '1px solid rgba(255,255,255,0.55)',
                                backgroundColor: active ? '#fff' : 'transparent',
                                color: active ? '#3f52a3' : '#fff',
                                transition: 'all 0.15s ease',
                            }}
                        >
                            <input
                                type="radio"
                                name={`supplementAction-${filename}`}
                                value={value}
                                checked={active}
                                onChange={() => handleSupplementActionChange(filename, value)}
                                style={{ display: 'none' }}
                            />
                            {icon}
                            {label}
                        </label>
                    );
                })}
            </div>
        );
    };

    // Info banner shown inside the video/audio modal when the file has a
    // pending "Replace File" attachment, so the Master Copier has context for
    // why validation is being requested.
    const renderPendingReplacementBanner = (filename) => {
        if (!alttextEnabled || !isMC) return null;
        const pending = attachmentNotificationMap[filename];
        if (!pending) return null;
        return (
            <div className="att-info-banner" style={{ margin: '10px 20px' }}>
                <FaPaperclip style={{ flexShrink: 0, color: '#dc3545' }} />
                <span>
                    <strong>Attention</strong> — "{pending.Filename}" was attached via the
                    Attachment tab to replace this file
                    {pending.Remarks ? (
                        <> (comment: <span dangerouslySetInnerHTML={{ __html: pending.Remarks }} />)</>
                    ) : null}. Please validate.
                </span>
            </div>
        );
    };

    // Render the "Add Comment" form for the Master Copier. The Author's own
    // comment form is rendered separately; this enables the Master Copier to
    // add a comment for the Create/Validate actions even when the Author left
    // none.
    const renderMcCommentForm = (item) => {
        if (!item) return null;
        const filename = item.filename;
        const action = getSupplementAction(filename);
        // Only prompt the Master Copier for a comment when none exists yet.
        // If a comment is already present (e.g. the Author's), the Validate/
        // Create action stays enabled but no empty comment box is shown.
        const hasAnyComment = (comments[filename] || []).length > 0;
        const mcCanAdd =
            isMC &&
            alttextEnabled &&
            supportsMcActions(filename) &&
            ['create', 'validate'].includes(action) &&
            !hasAnyComment;
        if (!mcCanAdd) return null;
        // Master Copier: show the comment box directly (no toggle button),
        // styled like the Image List modal.
        return (
            <div className="validate-comment-box" style={{ margin: 0, width: '100%' }}>
                <div className="comment-col" style={{ flex: '1 1 100%', maxWidth: '100%' }}>
                    <label className="comment-title" htmlFor={`supp-comment-${filename}`}>
                        <FaRegCommentDots />
                        <span>Comment</span>
                        {/* Required only for "Create" — matches the Image List modal. */}
                        {action === 'create' && (
                            <span className="comment-required">*</span>
                        )}
                    </label>
                    <textarea
                        id={`supp-comment-${filename}`}
                        ref={(el) => {
                            if (el) commentInputRef.current[filename] = el;
                        }}
                        className="validate-comment-input"
                        rows={2}
                        style={{ minHeight: '46px' }}
                        value={commentInput[filename] || ''}
                        placeholder="Add a comment for this file..."
                        onChange={(e) =>
                            setCommentInput(prev => ({
                                ...prev,
                                [filename]: e.target.value
                            }))
                        }
                    />
                    <div className="comment-actions">
                        <button
                            type="button"
                            className="comment-cancel-btn"
                            onClick={() =>
                                setCommentInput(prev => ({ ...prev, [filename]: '' }))
                            }
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="comment-save-btn"
                            onClick={() => addComment(item.path)}
                            disabled={!commentInput[filename]?.trim()}
                        >
                            <FaCheck /> Save
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // Render existing comments using the Image List comment-box styling.
    // Edit / Delete are shown only to the role that authored the comment.
    const renderCommentsList = (item) => {
        if (!item) return null;
        const filename = item.filename;
        const list = comments[filename] || [];
        if (!list.length) return null;
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
                {list.map((comment) => (
                    <div key={comment.id} className="validate-comment-box" style={{ margin: 0, width: '100%' }}>
                        <div className="comment-col" style={{ flex: '1 1 100%', maxWidth: '100%' }}>
                            {/* Outside the edit/view branch so the header stays
                                visible while the comment is being edited. */}
                            <label className="comment-title">
                                <FaRegCommentDots />
                                <span>Comment</span>
                            </label>
                            {editingCommentId === comment.id ? (
                                <>
                                    <textarea
                                        ref={editCommentRef}
                                        className="validate-comment-input"
                                        rows={2}
                                        style={{ minHeight: '46px' }}
                                        value={editingCommentText}
                                        onChange={(e) => setEditingCommentText(e.target.value)}
                                    />
                                    <div className="comment-actions">
                                        <button type="button" className="comment-cancel-btn" onClick={cancelEditComment}>
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            className="comment-save-btn"
                                            onClick={() => saveEditComment(item.path, comment.id)}
                                            disabled={!editingCommentText.trim()}
                                        >
                                            <FaCheck /> Save
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '11px', color: '#6b7280', flexWrap: 'wrap' }}>
                                        <span style={{ fontWeight: 600, color: '#1f2937' }}>{comment.userName}</span>
                                        {comment.role ? <span>({comment.role})</span> : null}
                                        <span>{comment.timestamp ? new Date(comment.timestamp).toLocaleString() : ''}</span>
                                    </div>
                                    <div className="comment-saved-text">{comment.text}</div>
                                    {comment.role === userProfile.role && (
                                        <div className="comment-actions">
                                            <button type="button" className="comment-edit-btn" onClick={() => startEditComment(comment.id, comment.text)}>
                                                <FaEdit /> Edit
                                            </button>
                                            <button type="button" className="comment-delete-btn" onClick={() => deleteCommentConfirm(item.path, comment.id)}>
                                                <FaTrashAlt /> Delete
                                            </button>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    // Author "Add Comment" flow: a button with intro text; once clicked it
    // opens the same Image List styled comment box.
    const renderAuthorCommentForm = (item) => {
        if (!item) return null;
        const filename = item.filename;
        const canAdd =
            userProfile.role === 'Author' &&
            (!comments[filename] || comments[filename].length === 0);
        if (!canAdd) return null;
        if (!showCommentInput[filename]) {
            return (
                <div className="add-comment-btn" style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <p style={{ margin: 0, fontWeight: 600, fontSize: '12px', color: '#1f2937' }}>Add a comment for this file:</p>
                    <button
                        onClick={() => {
                            setShowCommentInput(prev => ({ ...prev, [filename]: true }));
                            setTimeout(() => {
                                commentInputRef.current[filename]?.focus();
                            }, 0);
                        }}
                        style={{
                            padding: '6px 12px',
                            backgroundColor: '#3f52a3',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: 500,
                            width: 'fit-content'
                        }}
                    >
                        💬 Add Comment
                    </button>
                </div>
            );
        }
        return (
            <div className="validate-comment-box" style={{ margin: 0, width: '100%' }}>
                <div className="comment-col" style={{ flex: '1 1 100%', maxWidth: '100%' }}>
                    {/* No required marker: the Author's comment is optional —
                        they reach this box from the "Add Comment" button and can
                        cancel out of it. */}
                    <label className="comment-title" htmlFor={`supp-comment-${filename}`}>
                        <FaRegCommentDots />
                        <span>Comment</span>
                    </label>
                    <textarea
                        id={`supp-comment-${filename}`}
                        ref={(el) => {
                            if (el) commentInputRef.current[filename] = el;
                        }}
                        className="validate-comment-input"
                        rows={2}
                        style={{ minHeight: '46px' }}
                        value={commentInput[filename] || ''}
                        placeholder="Add a comment for this file..."
                        onChange={(e) =>
                            setCommentInput(prev => ({ ...prev, [filename]: e.target.value }))
                        }
                    />
                    <div className="comment-actions">
                        <button
                            type="button"
                            className="comment-cancel-btn"
                            onClick={() => {
                                // Discard the draft as well as closing the box, so
                                // re-opening "Add Comment" starts empty.
                                setShowCommentInput(prev => ({ ...prev, [filename]: false }));
                                setCommentInput(prev => ({ ...prev, [filename]: '' }));
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="comment-save-btn"
                            onClick={() => addComment(item.path)}
                            disabled={!commentInput[filename]?.trim()}
                        >
                            <FaCheck /> Save
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="supplementary-area">
               <header className="slider-header">
                            <h2>Supplementary files</h2>
                              <div>
                                               <button
                                                   className="close-btn"
                                                   title="Close"
                                                   ref={closeBtnRef}
                                                   tabIndex={0}
                                                   onClick={() => {
                                                       setSidebarClose(true);
                                                       setTimeout(() => {
                                                           const suppBtn = document.getElementById('supplementary-tab-btn');
                                                           if (suppBtn) suppBtn.focus();
                                                       }, 0);
                                                   }}
                                                   onKeyDown={e => {
                                                       if (e.key === 'Enter' || e.key === ' ') {
                                                           e.preventDefault();
                                                           setSidebarClose(true);
                                                           setTimeout(() => {
                                                               const suppBtn = document.getElementById('supplementary-tab-btn');
                                                               if (suppBtn) suppBtn.focus();
                                                           }, 0);
                                                       }
                                                   }}
                                               >
                                                   <FaTimes />
                                               </button>
                                           </div>
                        </header>
            <section
                className="filterTop"
                style={{ display: "flex", gap: "8px", alignItems: "center", padding: "10px" }}
                >
                <label htmlFor="search-files" style={{ fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>Search:</label>
                <input
                    id="search-files"
                    type="text"
                    placeholder="Search files by name or extension..."
                    value={searchText}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    style={{
                    padding: "6px 10px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    fontSize: "13px",
                    flex: "1",
                    maxWidth: "135px"
                    }}
                    aria-label="Search files by name or extension"
                    title="Search files by name or extension"
                />
                {/* {searchText && (
                    <button
                    onClick={() => setSearchText('')}
                    style={{
                        padding: "4px 8px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        background: "#fff",
                        cursor: "pointer",
                        fontSize: "12px"
                    }}
                    title="Clear search"
                    >
                    Clear
                    </button>
                )} */}
                </section>
            {/* Loading Overlay with CSS Loader */}
            {(isVideoLoading || isImageLoading || isAudioLoading) && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9998,
                    backdropFilter: 'blur(5px)'
                }}>
                    <CSSLoader />
                </div>
            )}

            {/* Video Player Modal with blur background */}
            <div className={`modal-outer ${showVideoModal ? "active" : ""}`} style={{
                backgroundColor: showVideoModal ? 'rgba(0, 0, 0, 0.8)' : 'transparent',
                backdropFilter: showVideoModal ? 'blur(5px)' : 'none'
            }}>
                <div className="modal video-modal" style={{
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                    width: 'auto',
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                    overflow: 'hidden',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
                }}>
                    <div className="modal-header">
                        <h3>{currentVideo?.filename}</h3>
                        <div className="header-actions">
                            {availableSubtitles.length > 0 && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <label htmlFor="subtitle-select" style={{ whiteSpace: 'nowrap' }}>
                                        Subtitles:
                                    </label>
                                    <select
                                        id="subtitle-select"
                                        value={selectedSubtitle ? subtitleTracks.indexOf(selectedSubtitle) : 'none'}
                                        onChange={handleSubtitleChange}
                                    >
                                        <option value="none">None</option>
                                        {subtitleTracks.map((track, index) => (
                                            <option key={index} value={index}>
                                                {track.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            {renderMcActionButtons(currentVideo?.filename)}
                            <button
                                className="modal-download-btn"
                                title="Download Video"
                                onClick={() => modalFileDownload(currentVideo)}
                                disabled={!!isDownloading[currentVideo?.path]}
                            >
                                {isDownloading[currentVideo?.path] ? <SmallCSSLoader /> : <MdDownload />}
                            </button>
                            <button className="modal-close-btn" onClick={closeVideoModal}>
                                <FaTimes />
                            </button>
                        </div>
                    </div>
                    {renderPendingReplacementBanner(currentVideo?.filename)}
                    <div className="modal-body" style={{ padding: '0', height: 'calc(90vh - 80px)' }}>
                        {currentVideo && (
                            <div style={{ position: 'relative', width: '100%', height: '100%', backgroundColor: '#000' }}>
                                {isVideoBuffering && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        pointerEvents: 'none',
                                        zIndex: 2
                                    }}>
                                        <span style={{
                                            width: '48px',
                                            height: '48px',
                                            border: '4px solid rgba(255, 255, 255, 0.3)',
                                            borderTopColor: '#fff',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite',
                                            display: 'inline-block'
                                        }}></span>
                                    </div>
                                )}
                                <video
                                    ref={videoRef}
                                    controls={!isVideoBuffering}
                                    autoPlay
                                    crossOrigin="anonymous"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain'
                                    }}
                                    src={currentVideo.url}
                                    onError={() => handleStreamError('video')}
                                    onWaiting={() => setIsVideoBuffering(true)}
                                    onCanPlay={() => setIsVideoBuffering(false)}
                                    onPlaying={() => setIsVideoBuffering(false)}
                                      onLoadedMetadata={() => {
                                        if (selectedSubtitle && videoRef.current) {
                                            const tracks = videoRef.current.textTracks;
                                            for (let i = 0; i < tracks.length; i++) {
                                                tracks[i].mode = i === 0 ? 'showing' : 'disabled';
                                            }
                                        }
                                    }}
                                >
                                    {subtitleTracks.map((track, index) => (
                                        <track
                                            key={index}
                                            kind="subtitles"
                                            src={track.src}
                                            srcLang={track.srcLang}
                                            label={track.label}
                                            default={index === 0}
                                        />
                                    ))}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer" style={{ padding: '15px 20px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-start', gap: '15px', height: 'auto', minHeight: '80px', maxHeight: '150px', overflowY: 'auto' }}>
                        {/* Comments Section on Left Side - 50% width (only when alttextEnabled) */}
                        {alttextEnabled && <div style={{ flex: '0 0 60%', maxWidth: '60%', display: 'flex', flexDirection: 'column', gap: '12px', overflowY: 'auto', paddingRight: '10px' }}>
                            {/* Display existing comments */}
                            {renderCommentsList(currentVideo)}

                            {/* Comment Input Form (Author) */}
                            {renderAuthorCommentForm(currentVideo)}
                            {/* Master Copier comment form */}
                            {renderMcCommentForm(currentVideo)}
                        </div>}
                    </div>
                </div>
            </div>

            {/* Audio Player Modal with blur background */}
            <div className={`modal-outer ${showAudioModal ? "active" : ""}`} style={{
                backgroundColor: showAudioModal ? 'rgba(0, 0, 0, 0.8)' : 'transparent',
                backdropFilter: showAudioModal ? 'blur(5px)' : 'none'
            }}>
                <div className="modal audio-modal" style={{ 
                    width: '1000px',
                    maxWidth: '95vw',
                    height: 'auto',
                    maxHeight: '90vh',
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                    overflow: 'auto',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <div className="modal-header">
                        <h3>{currentAudio?.filename}</h3>
                        <div className="header-actions">
                            {availableSubtitles.length > 0 && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <label htmlFor="subtitle-select-audio" style={{ fontSize: '14px', color: '#fff', whiteSpace: 'nowrap' }}>
                                        Subtitles:
                                    </label>
                                    <select 
                                        id="subtitle-select-audio"
                                        value={selectedSubtitle ? subtitleTracks.indexOf(selectedSubtitle) : 'none'}
                                        onChange={handleSubtitleChange}
                                        style={{ 
                                            padding: '4px 8px', 
                                            borderRadius: '4px', 
                                            border: '1px solid #ccc',
                                            fontSize: '14px',
                                            minWidth: '120px'
                                        }}
                                    >
                                        <option value="none">None</option>
                                        {subtitleTracks.map((track, index) => (
                                            <option key={index} value={index}>
                                                {track.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            {renderMcActionButtons(currentAudio?.filename)}
                            <button
                                className="modal-download-btn"
                                title="Download Audio"
                                onClick={() => modalFileDownload(currentAudio)}
                                disabled={!!isDownloading[currentAudio?.path]}
                            >
                                {isDownloading[currentAudio?.path] ? <SmallCSSLoader /> : <MdDownload />}
                            </button>
                            <button className="modal-close-btn" onClick={closeAudioModal}>
                                <FaTimes />
                            </button>
                        </div>
                    </div>
                    {renderPendingReplacementBanner(currentAudio?.filename)}
                    <div className="modal-body" style={{ padding: '20px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {currentAudio && (
                            <div style={{ 
                                display: 'flex', 
                                flexDirection: 'column', 
                                alignItems: 'center', 
                                gap: '20px',
                                width: '100%'
                            }}>
                                <div style={{ 
                                    fontSize: '48px', 
                                    color: '#3f52a3',
                                    marginBottom: '10px'
                                }}>
                                    🎵
                                </div>
                                <audio
                                    ref={audioRef}
                                    controls
                                    crossOrigin="anonymous"
                                    style={{ 
                                        width: '100%',
                                        maxWidth: '500px'
                                    }}
                                    src={currentAudio.url}
                                    onError={() => handleStreamError('audio')}
                                    onLoadedMetadata={() => {
                                        if (selectedSubtitle && audioRef.current) {
                                            const tracks = audioRef.current.textTracks;
                                            for (let i = 0; i < tracks.length; i++) {
                                                tracks[i].mode = i === 0 ? 'showing' : 'disabled';
                                            }
                                        }
                                    }}
                                >
                                    {subtitleTracks.map((track, index) => (
                                        <track
                                            key={index}
                                            kind="subtitles"
                                            src={track.src}
                                            srcLang={track.srcLang}
                                            label={track.label}
                                            default={index === 0}
                                        />
                                    ))}
                                    Your browser does not support the audio tag.
                                </audio>

                             {/* Audio captions render layer */}
                                {selectedSubtitle && activeAudioCaption ? (
                                    <div style={{
                                        marginTop: '8px',
                                        width: '100%',
                                        maxWidth: '500px',
                                        backgroundColor: '#2e2e2fff',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '6px',
                                        padding: '10px 14px',
                                        fontSize: '13px',
                                        lineHeight: '1.5',
                                        color: '#fff',
                                        textAlign: 'center',
                                        whiteSpace: 'pre-wrap',
                                    }}>
                                        {activeAudioCaption}
                                    </div>
                                ) : null}
                            </div>
                        )}
                    </div>
                    <div className="modal-footer-audio" style={{ padding: '15px 20px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-start', gap: '15px', height: 'auto', minHeight: 'auto', overflowY: 'visible' }}>
                        {/* Comments Section on Left Side - 50% width (only when alttextEnabled) */}
                        {alttextEnabled && <div style={{ flex: '0 0 60%', maxWidth: '60%', display: 'flex', flexDirection: 'column', gap: '12px', overflowY: 'visible', paddingRight: '10px' }}>
                            {/* Display existing comments */}
                            {renderCommentsList(currentAudio)}

                            {/* Comment Input Form (Author) */}
                            {renderAuthorCommentForm(currentAudio)}
                            {/* Master Copier comment form */}
                            {renderMcCommentForm(currentAudio)}
                        </div>}
                    </div>
                </div>
            </div>            {/* Image Viewer Modal with blur background */}
            <div className={`modal-outer ${showImageModal ? "active" : ""}`} style={{
                backgroundColor: showImageModal ? 'rgba(0, 0, 0, 0.8)' : 'transparent',
                backdropFilter: showImageModal ? 'blur(5px)' : 'none'
            }}>
                <div className="modal image-modal" style={{ 
                    width: '1000px',
                    maxWidth: '95vw',
                    height: 'auto',
                    maxHeight: '90vh',
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                    overflow: 'auto',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <div className="modal-header">
                        <h3>{currentImage?.filename}</h3>
                        <div className="header-actions">
                            {renderMcActionButtons(currentImage?.filename)}
                            <button
                                className="modal-download-btn"
                                title="Download Image"
                                onClick={() => modalFileDownload(currentImage)}
                                disabled={!!isDownloading[currentImage?.path]}
                            >
                                {isDownloading[currentImage?.path] ? <SmallCSSLoader /> : <MdDownload />}
                            </button>
                            <button className="modal-close-btn" onClick={closeImageModal}>
                                <FaTimes />
                            </button>
                        </div>
                    </div>
                    {renderPendingReplacementBanner(currentImage?.filename)}
                    <div className="modal-body" style={{ padding: '20px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {currentImage && (
                            <>
                                {isImageRendering && (
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <span style={{
                                            width: '48px',
                                            height: '48px',
                                            border: '4px solid rgba(63, 82, 163, 0.25)',
                                            borderTopColor: '#3f52a3',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite',
                                            display: 'inline-block'
                                        }}></span>
                                    </div>
                                )}
                                <img
                                    src={currentImage.url}
                                    alt={currentImage.filename}
                                    crossOrigin="anonymous"
                                    onError={() => handleStreamError('image')}
                                    onLoad={() => setIsImageRendering(false)}
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        objectFit: 'contain',
                                        borderRadius: '8px',
                                        display: isImageRendering ? 'none' : 'block'
                                    }}
                                />
                            </>
                        )}
                    </div>
                    <div className="modal-footer" style={{ padding: '15px 20px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-start', gap: '15px', height: 'auto', minHeight: 'auto', overflowY: 'visible' }}>
                        {/* Comments Section on Left Side */}
                        <div style={{ flex: '0 0 60%', maxWidth: '60%', display: 'flex', flexDirection: 'column', gap: '12px', overflowY: 'visible', paddingRight: '10px' }}>
                            {/* Display existing comments */}
                            {renderCommentsList(currentImage)}

                            {/* Comment Input Form (Author) */}
                            {renderAuthorCommentForm(currentImage)}
                            {/* Master Copier comment form (GIF files) */}
                            {renderMcCommentForm(currentImage)}
                        </div>
                    </div>
                </div>
            </div>

            {/* Delete Confirmation Modal */}
            <div className={`modal-outer ${showconfirm ? "active" : ""}`}>
                <div className="modal confirmation-popup">
                    <div className="modal-header">
                        <h1>Confirm Delete</h1>
                        <button className="modal-close-btn" onClick={() => { setConfirm(false); setPendingCommentDelete(null); }}><FaTimes /></button>
                    </div>
                    <div className="modal-body">
                        <p style={{ textAlign: 'center', margin: '10px 0' }}>
                            {pendingCommentDelete ? 'Are you sure you want to delete this comment?' : 'Are you sure you want to delete this file?'}
                        </p>
                    </div>
                    <div className="modal-footer">
                        <button className="primary" onClick={() => {
                            if (pendingCommentDelete) {
                                deleteComment(pendingCommentDelete.filePath, pendingCommentDelete.commentId);
                                setPendingCommentDelete(null);
                                setConfirm(false);
                            } else {
                                deleteAttchment();
                            }
                        }}>Yes</button>
                        <button className="outline-secondary" onClick={() => { setConfirm(false); setPendingCommentDelete(null); }}>No</button>
                    </div>
                </div>
            </div>

            <div className="supplementary-list">
                {!["Editor", "Author", "Master Copier"].includes(userProfile.role) ? <div className="upload-btn-wrapper">
                    <FaCloudUploadAlt />
                    <p>Choose file or drag here</p>
                    <input type="file" onChange={(e) => handleFileupload(e)} ref={fileInputRef} />
                </div> : ""}
                {getFilteredFiles().length !== 0 ? getFilteredFiles().map((item, index) => {
                    const filename = item.path.split('/').pop();
                    const isVideo = isVideoFile(filename);
                    const isImage = isImageFile(filename);
                    const isAudio = isAudioFile(filename);
                    const showDownload = shouldShowDownloadIcon(filename);
                    const isCurrentlyLoading = loadingItemId === item.path;
                    
                    return (
                        <div className="supplementary-list-group" key={index}>
                            <div className="supplementary-action">
                                {/* View button for video files */}
                                {isVideo && (
                                    <button 
                                        className="view-btn" 
                                        title="View Video" 
                                        onClick={() => playVideo(item)}
                                        disabled={isCurrentlyLoading || isVideoLoading}
                                        style={{ 
                                            background: 'none',
                                            border: 'none',
                                            cursor: isCurrentlyLoading ? 'not-allowed' : 'pointer',
                                            opacity: isCurrentlyLoading ? 0.6 : 1,
                                            // display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#3f52a3',
                                            fontSize: '16px'
                                        }}
                                    >
                                        {isCurrentlyLoading ? (
                                            <span className="loader"></span>
                                        ) : (
                                            <FaEye />
                                        )}
                                    </button>
                                )}
                                
                                {/* View button for audio files */}
                                {isAudio && (
                                    <button 
                                        className="view-btn" 
                                        title="View Audio" 
                                        onClick={() => playAudio(item)}
                                        disabled={isCurrentlyLoading || isAudioLoading}
                                        style={{ 
                                            background: 'none',
                                            border: 'none',
                                            cursor: isCurrentlyLoading ? 'not-allowed' : 'pointer',
                                            opacity: isCurrentlyLoading ? 0.6 : 1,
                                            // display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#3f52a3',
                                            fontSize: '16px'
                                        }}
                                    >
                                        {isCurrentlyLoading ? (
                                            <SmallCSSLoader />
                                        ) : (
                                            <FaEye />
                                        )}
                                    </button>
                                )}
                                
                                {/* View button for images */}
                                {isImage && (
                                    <button 
                                        className="view-btn" 
                                        title="View Image" 
                                        onClick={() => viewImage(item)}
                                        disabled={isCurrentlyLoading || isImageLoading}
                                        style={{ 
                                            background: 'none',
                                            border: 'none',
                                            cursor: isCurrentlyLoading ? 'not-allowed' : 'pointer',
                                            // marginRight: '5px',
                                            opacity: isCurrentlyLoading ? 0.6 : 1,
                                            // display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#3f52a3',
                                            fontSize: '16px'
                                        }}
                                    >
                                        {isCurrentlyLoading ? (
                                            <SmallCSSLoader />
                                        ) : (
                                            <FaEye />
                                        )}
                                    </button>
                                )}
                                
                                {/* Download button only for non-media files */}
                                {showDownload && (
                                    <button 
                                        className="download-btn" 
                                        title="Download" 
                                        onClick={() => fileDownload(filename, item.path)}
                                        disabled={!!isDownloading[item.path]}
                                        style={{
                                            opacity: isDownloading[item.path] ? 0.6 : 1,
                                            cursor: isDownloading[item.path] ? 'not-allowed' : 'pointer',
                                            padding: '0 5px 0 0',
                                        }}
                                    >
                                        {isDownloading[item.path] ? <SmallCSSLoader /> : <MdDownload />}
                                    </button>
                                )}
                                
                                {/* Pending "Replace File" attachment badge (Master Copier only) */}
                                {alttextEnabled && isMC && attachmentNotificationMap[filename] && (
                                    <FaPaperclip
                                        title={`Attention — "${attachmentNotificationMap[filename].Filename}" was attached to replace this file and needs validation`}
                                        style={{ color: '#dc3545', fontSize: '14px', margin: '0 5px 0 0' }}
                                    />
                                )}

                                {/* Delete button */}
                                {userProfile?.role === item?.metadata.role && (
                                    <button
                                        className="close-btn"
                                        title="delete"
                                        onClick={() => deleteConfirm(item)}
                                          style={{
                                            // padding: 0,
                                            padding: '0 5px 0 0',
                                        }}
                                    >
                                        <FaTrash />
                                    </button>
                                )}
                            </div>
                            <p title={filename} style={{width: '65%'}}>
                                {filename}
                                {/* {isVideo && (
                                    <span style={{ color: '#28a745', marginLeft: '5px' }}>🎬</span>
                                )}
                                {isAudio && (
                                    <span style={{ color: '#28a745', marginLeft: '5px' }}>🎵</span>
                                )}
                                {isImage && (
                                    <span style={{ color: '#007bff', marginLeft: '5px' }}>🖼️</span>
                                )}
                                {isSubtitle && (
                                    <span style={{ color: '#6c757d', marginLeft: '5px' }}>📝 CC</span>
                                )} */}
                            </p>
                            {/* <p>role: {item?.metadata.role === undefined ? 'Admin' : item?.metadata.role}</p>
                            <span>Date: {moment(item.createdOn).format("DD-MM-YYYY - HH:mm:ss")}</span> */}
                            
                            {/* Display comments if exist */}
                            {comments[filename] && comments[filename].length > 0 && (
                                <div style={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    {comments[filename].map((comment) => (
                                        <div key={comment.id} style={{
                                            padding: '10px 12px',
                                            backgroundColor: '#f0f4ff',
                                            borderLeft: '3px solid #3f52a3',
                                            borderRadius: '4px',
                                            fontSize: '12px'
                                        }}>
                                            <div style={{ fontWeight: '600', color: '#1f2937', marginBottom: '4px', wordWrap: 'break-word' }}>
                                                Comment: {comment.text}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )
                }) : searchText && fileData.length !== 0 ? (
                    <div style={{ padding: '16px', textAlign: 'center', color: '#ffff' }}>
                        <p>No files match "{searchText}"</p>
                    </div>
                ) : <NodataFound />}
             </div>
        </div>
    )
}
export default Supplementary;
          